// All helpers mutate the passed `days` array in place. Callers wrap them in a
// single useAutosaveEditor applyUpdate() so each move is one undo step + one
// autosave tick.

export function moveDayInList(days, fromIdx, toIdx) {
  if (!Array.isArray(days)) return;
  if (fromIdx === toIdx || fromIdx < 0 || toIdx < 0 || fromIdx >= days.length || toIdx >= days.length) return;
  const [moved] = days.splice(fromIdx, 1);
  days.splice(toIdx, 0, moved);
}

export function moveExerciseInDay(days, dayIdx, fromIdx, toIdx) {
  if (!Array.isArray(days) || !days[dayIdx]) return;
  const exercises = days[dayIdx].exercises;
  if (!Array.isArray(exercises)) return;
  if (fromIdx === toIdx || fromIdx < 0 || toIdx < 0 || fromIdx >= exercises.length || toIdx >= exercises.length) return;
  const [moved] = exercises.splice(fromIdx, 1);
  exercises.splice(toIdx, 0, moved);
}

export function moveExerciseAcrossDays(days, fromDayIdx, fromExIdx, toDayIdx, toExIdx) {
  if (!Array.isArray(days) || !days[fromDayIdx] || !days[toDayIdx]) return;
  const fromList = days[fromDayIdx].exercises;
  const toList = days[toDayIdx].exercises;
  if (!Array.isArray(fromList) || !Array.isArray(toList)) return;
  if (fromExIdx < 0 || fromExIdx >= fromList.length) return;
  const [moved] = fromList.splice(fromExIdx, 1);
  const insertAt = Math.max(0, Math.min(toExIdx, toList.length));
  toList.splice(insertAt, 0, moved);
}
